import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import MyOrderItem from "./MyOrderItem";
import ReOrderPopup from "../../../components/Popup/ReOrderPopup";
import ReviewPopup from "../../../components/Popup/ReviewPopup";
import product from "../../../assets/img/detailproduct.png";
import { MY_PAGE_DETAIL_URL, MY_PAGE_ORDER_CANCEL_URL, MY_PAGE_REORDER_URL } from "../../../utils/urls";
import instance from "../../../services/services";
import { formatLocalString, formatPhoneNumber } from "../../../utils/validation";
import PopupLoginError from "../../../components/Popup/LoginError";
import DeliveryStatusPopup from "../../../components/Popup/DeliveryStatusPopup";
import test from "../../../assets/img/event_poster.png"
import { useLanguage } from "../../../hooks/useLanguage";

function OrderDetail(){
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || location?.state?.type; 
  const orderNumber = searchParams.get('orderNumber') || location?.state?.orderNumber; 
  const [isShow, setIsShow] = useState({}); // 패키지 보기 버튼
  const [requestReorder, setRequestReorder] = useState(false);
  const [writeReview, setWriteReview] = useState(false);
  const [orderDetail, setOrderDetail] = useState(null); // 주문정보
  const [paymentDetail, setPaymentDetail] = useState(null); // 결제 정보
  const [productDetail, setProductDetail] = useState(null); // 상품 정보
  const [estimateDetail, setEstimateDetail] = useState(null);   // 견적서 데이터
  const [deliveryDetail, setDeliveryDetail] = useState(null); // 배송지 정보
  const [depositDetail, setDepositDetail] = useState(null); // 보증금 정보
  const [isPopupLoginError, setIsPopupLoginError] = useState("") // 팝업
  const [isStatusPopup, setStatusPopup ] = useState(false); // 배송조회 팝업
  const handleStatusPopup = () => {
    setStatusPopup(true)
  };
  
  // 재주문 팝업 
  const handleRequestReorder = (orderSeq) => {
    // API 호출
    instance.post(MY_PAGE_REORDER_URL, {
      order_kind: type,
      order_seq: orderSeq
    })
    .then((response) => {
      if (response.data.code === 200) {
        // API 호출 성공 시 팝업 열기
        setRequestReorder(true);
      } else {
        setIsPopupLoginError({
          message: '재주문 요청에 실패했습니다.',
          action: 'refresh'
        });
      }
    })
    .catch((error) => {
      console.error('재주문 요청 오류:', error);
      setIsPopupLoginError({
        message: '재주문 요청 중 오류가 발생했습니다.',
        action: 'refresh'
      });
    });
  };

  // 연장 버튼 클릭 핸들러 
  const handleExtension = () => {
    const state = {
      orderNumber,
      rental_store_name: orderDetail?.return_store_name,
      rental_sdate: orderDetail?.rental_edate
    };
    
    navigate(`/myPage/orderExtension/${type}?orderNumber=${orderNumber}`, { state });
  };

  // 패키지 보기 버튼
  const handleShow = (itemId) => {
    setIsShow(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const handleWriteReview = ()=>{
    setWriteReview(true);
  };

  // 목록 버튼 클릭 핸들러
  const handleBackToList = () => {
    navigate(`/myPage/orderManagement?type=${type}`);
  };

 // 주문 상세 데이터
  useEffect(() => {
    const fetchOrderDetail = async () => {
      try { 
        const response = await instance.post(MY_PAGE_DETAIL_URL,{
          order_seq: orderNumber,
          order_kind: type,
          item_seq: ""
        });
        setOrderDetail(response.data.data.order_info);
        setPaymentDetail(response.data.data.pay_info);
        setProductDetail(response.data.data.items);
        setEstimateDetail(response.data.data.estimate_info);
        setDeliveryDetail(response.data.data.delivery_info);
        setDepositDetail(response.data.data.deposit_info);
      } catch (error) {
        console.error('주문 상세 데이터 가져오기 실패:', error);
      }
    };
    fetchOrderDetail();
  }, [orderNumber, type]);

  const handleOrderCancel = (orderSeq)=>{
    instance.post(MY_PAGE_ORDER_CANCEL_URL, {
      order_seq: orderSeq,
      })
      .then((response) => {
        if (response.data.code === 200) {
          setIsPopupLoginError({
            message: '주문을 취소처리 합니다.',
            action: 'navigate_login'
          });
        } else {
          // 실패 시에도 팝업 표시
          setIsPopupLoginError({
            message: response.data.message || '주문취소에 실패했습니다.',
            action: 'navigate_login'
          });
        }
      })
      .catch((error) => {
        console.log(error);
        setIsPopupLoginError({
          message: '주문취소에 실패했습니다.',
          action: 'navigate_login'
        });
      })
  };

  const handleConfirm = () => {
    if (isPopupLoginError.action === 'navigate_login') {
      window.location.reload();
    } else if (isPopupLoginError.action === 'refresh') {
      navigate('/');
    }
    setIsPopupLoginError(false); // 팝업 닫기
  };


  const handleProductDetail = (item) => {
    window.open(`/product/detail/${item.goods_seq}`, '_blank');
  }
  
  // 상태명 → 클래스명 매핑
  const STATUS_CLASS = {
    '주문접수': 'badge_order',
    '장비세팅': 'badge_setting',
    '계약대기중': 'badge_contract_wait',
    '대여중': 'badge_rent',
    '대여완료중': 'badge_rent_done',
    '반납지연': 'badge_return_delay',
    '주문연장': 'badge_extend',
    '반납완료': 'badge_return_done',
    '주문취소': 'badge_cancel',
    '확인중': 'badge_check',
    '확인완료': 'badge_check_done',
    '입금전': 'badge_before_pay',
    '배송준비중': 'badge_delivery_ready',
    '배송대기중': 'badge_delivery_wait',
    '배송중': 'badge_delivering',
    '배송완료': 'badge_delivery_done',
    '반품': 'badge_return',
    '교환': 'badge_exchange',
  };

  return(
    <div className="my_table mt_48">
      {type !== 'sale' && (
        <div className="my_container order_detail_form">
          <div className="order_title">
            <h3>{t('order_info')}</h3> 
          </div>
          <ul className="default_info_table v2 vertical">
            <li className="info_item">
              <div className="label">
                <span>{t('order_date')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.regist_date.split(' ')[0]}
                </div>
              </div>
            </li>

            {/* '주문상태' 는 MyOrderItem.js 뱃지 텍스트, 버튼(텍스트,컬러) 동일합니다 */}
            <li className="info_item">
              <div className="label">
                <span>{t('order_status')}</span> 
              </div>
              <div className="form_info">
                <div className="info_detail flex-center-8 py-0 f_wrap">
                  <div className={`badge_big ${STATUS_CLASS[orderDetail?.step_name] || ''}`}>
                    {orderDetail?.step_name}
                  </div>
                  {/* 반납완료 */}
                  <div className="detail_btn btn_group_4 mg_0"> 
                  {['대여중', '배송중', '배송완료', '반납지연'].includes(orderDetail?.step_name) && (
                      <button
                        type="button"
                        className="black default_btn xs"
                        onClick={handleExtension}
                    >
                      {t('extension')}
                    </button>
                    )}

                    {orderDetail?.step_name === '반납완료' && (
                    <button
                      type="button"
                      className="black default_btn xs"
                      onClick={() => handleRequestReorder(orderDetail?.order_seq)}
                    >
                      {t('reorder')}
                    </button>
                    )}

                    {(orderDetail?.step_name === '주문접수' || orderDetail?.step_name === '배송대기중') && (
                    <button
                      type="button"
                      className="gray default_btn xs"
                      onClick={() => handleOrderCancel(orderDetail?.order_seq)}
                    >
                      {t('order_cancel')}
                    </button>
                    )}
                    
                    {/* 배송조회 버튼 */}
                    {type !== 'visit' && ['배송중', '배송완료', '대여중', '반납지연', '주문연장', '반납완료'].includes(orderDetail?.step_name) && (
                      <button
                      type="button"
                      className="white default_btn xs"
                      onClick={handleStatusPopup}
                    >
                      {t('delivery_search')}
                    </button>
                    )}
                  </div>
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t('order_number')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.order_seq}
                </div> 
              </div>
            </li>
            {/* 견적서 > 평점 미표출 */}
            <li className="info_item">
              <div className="label">
                <span>{t('rating')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  <div className="flex-center">
                    <i className="star_icon"></i> 
                    {orderDetail?.grade_star ? (
                      <div className="flex-center-16">
                        <span>{orderDetail?.grade_star}</span>
                        {orderDetail?.point_rate_by_grade > 0 && (
                          <p>
                            {orderDetail?.point_rate_by_grade}%({orderDetail?.point_by_grade ? formatLocalString(Number(orderDetail?.point_by_grade)) : 0})포인트 지급
                          </p>
                        )}
                      </div>
                    ) : (
                      <div className="flex-center-4">
                        <span>-</span>
                        <p className="g-70">{t('return_info2')}</p>
                      </div>
                    )}
                    </div>
                </div>
              </div>
            </li>  
            <li className="info_item">
              <div className="label">
                <span>{t('rental_info')}</span>  {/* 매장, 견적서 */}
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.rental_store_name} {orderDetail?.rental_sdate}   {/* 매장, 견적서 */}
                </div>
              </div>
            </li>    
            <li className="info_item">
              <div className="label">
                <span>{t('total_product_quantity_txt')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.total_ea}{t('quantity_count_txt')}
                </div>
              </div>
            </li> 
            <li className="info_item">
              <div className="label">
                <span>{t("return_info")}</span>   {/* 매장, 견적서 */}
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.return_store_name} {orderDetail?.rental_edate}   {/* 매장, 견적서 */}
                </div>
              </div>
            </li>          
            <li className="info_item">
              <div className="label">
                <span>{t('total_rental_days4')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.rental_period}{t('days_txt')}
                </div>
              </div>
            </li>
            {/* '반납완료'상태에서만 매장 및 직원들에 대한 이용평가 작성 가능 */}
            {orderDetail?.step_name === '반납완료' && (
            <li className="info_item">
              <div className="label">
                <span>{t('evaluation')}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  <div className="detail_btn btn_group_4 mg_0"> 
                    {orderDetail?.rating_flag === 'Y' ? (
                      <button 
                        type="button" 
                        className="default_btn gray xs"
                        style={{flexBasis:'auto'}}
                      >
                      {t('evaluation_completed')}
                      </button>
                    ) : (
                      <button 
                        type="button" 
                        className="default_btn gray xs"
                        onClick={handleWriteReview}
                        style={{flexBasis:'auto'}}
                    >
                      {t('evaluation_info7')}
                    </button>
                    )}
                  </div>
                </div>
              </div>
            </li>
            )}
          </ul>
        </div>
      )}

      {orderDetail?.step_name === '반납완료' && (
            <div className="my_container order_detail_form">
              <div className="order_title">
                <h3>{t('deposit_info2')}</h3>
              </div>
              <ul className="default_info_table v2">
                <li className="info_item">
                  <div className="label label_start">
                    <span>{t('refund_amount2')}</span>
                  </div>
                  <div className="form_info payment_info">
                    <div className="info_detail flex-8 column">
                      <p className="price red">
                        {depositDetail?.deposit_price ? formatLocalString(Number(depositDetail?.deposit_price)) : "환불 대기중"}
                        {depositDetail?.deposit_price && <i className="won xl">{t('price_txt')}</i>}
                      </p>
                      <div className="text_small_b g-80 flex-4 column">
                        <div className="flex-center-4">
                          {t('payment_method_refund2')}: {depositDetail?.deposit_refund ? formatLocalString(Number(depositDetail?.deposit_refund)) : "-"}원
                        </div>
                        <div className="flex-center-4">
                          {t('reason_txt')}: {depositDetail?.deposit_reason ? depositDetail?.deposit_reason : "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            )}

      {/* order details :: 판매 주문상품 정보 */}
      {type === 'sale' && (
        <div className="my_container order_detail_form">
          <div className="order_title">
            <h3>{t('order_product_info')}</h3> 
          </div>
          <MyOrderItem type="sale" orderList={productDetail?.bundleMain} orderData={orderDetail} orderType="sale_detail"/>
        </div>
      )}

      {orderDetail?.step_name === '반품완료' && orderDetail?.return_status === '반품처리중' && orderDetail?.return_status === '반품신청' && (
        <div className="py-16 flex-4 column reason_box">
          <p className="text_small_b">반품사유 : 단순변심 / 회수방법: 회수신청</p>
          <p className="text_small_b g-80">생각했던 느낌이 아니었고, 착용이 불편했습니다 빠른 반품 처리 요청드립니다.</p>
          
          {/* 오배송, 상품상이, 상품불량 일 경우 : 상품 반품 사유 이미지 존재시 출력 */}
          {orderDetail?.step_name === '반품완료' && (
          <div className="img_attach_box">
            <ul className="preview_list">
              <li className="default_btn ic_lg">
                <img
                  className="object-cover"
                  src={test}
                  alt="이미지 첨부"
                  loading="lazy"
                />
              </li>
            </ul>
          </div>
          )}
        </div>
      )}

      {/* order details :: 택배 배송지 정보  */}
      {(type === 'parcel' || type === 'sale' ) && orderDetail?.step_name !== '주문취소' && (
        <div className="my_container order_detail_form">
          <div className="order_title">
            <h3>{t("delivery_info")}</h3>
          </div>
          <ul className="default_info_table v2">
            <li className="info_item">
              <div className="label">
                <span>{t("recipient")}</span> 
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {deliveryDetail?.recipient_user_name}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("phone_number")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {formatPhoneNumber(deliveryDetail?.recipient_cellphone)}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("delivery_address")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {deliveryDetail?.recipient_address_street} {deliveryDetail?.recipient_address_detail}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("delivery_message")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {deliveryDetail?.recipient_memo ? deliveryDetail?.recipient_memo : '배송 메시지가 없습니다.'}
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}


      {/* order details :: 견적서 주문자 정보 */}
      {type === 'estimate' && (
        <div className="my_container order_detail_form">
          <div className="order_title">
            <h3>{t("orderer_info")}</h3> 
          </div>
          <ul className="default_info_table v2 vertical">
            <li className="info_item">
              <div className="label">
                <span>{t("name")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.order_user_name}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("ceo")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.business_ceo}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("phone_number")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {formatPhoneNumber(orderDetail?.mem_phone)}
                </div> 
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("alternate_contact")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {formatPhoneNumber(orderDetail?.mem_phone2)}
                </div>
              </div>
            </li>  
            <li className="info_item">
              <div className="label">
                <span>{t("business_name")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.business_name}
                </div>
              </div>
            </li>   
            <li className="info_item">
              <div className="label">
                <span>{t("email")}</span> 
              </div>
              <div className="form_info">
                <div className="info_detail flex-center-16 py-0">
                  {orderDetail?.email}
                </div>
              </div>
            </li>        
            <li className="info_item">
              <div className="label">
                <span>{t("business_registration_number")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {orderDetail?.business_num}
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}


      {/* order details :: 견적서 프로그램 정보 */}
      {type === 'estimate' && (
        <div className="my_container order_detail_form">
          <div className="order_title">
            <h3>{t("program_info")} {t("program_info2")}</h3> 
          </div>
          <ul className="default_info_table v2 vertical">
            <li className="info_item">
              <div className="label">
                <span>{t("person_in_charge")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_manager_name}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("cinematographer")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_director}
                </div>
              </div>
            </li>  
            <li className="info_item">
              <div className="label">
                <span>{t("contact")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {formatPhoneNumber(estimateDetail?.project_manager_phone)}
                </div> 
              </div>
            </li>         
            <li className="info_item">
              <div className="label">
                <span>{t("test_schedule")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_test_date}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("production_company")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_production}
                </div>
              </div>
            </li>  
            <li className="info_item">
              <div className="label">
                <span>{t("shooting_start_schedule")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_start_date}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("program_name")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_name}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("program_type")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_type_txt}
                </div>
              </div>
            </li>
            <li className="info_item">
              <div className="label">
                <span>{t("work_content")}</span> 
              </div>
              <div className="form_info">
                <div className="info_detail">
                  {estimateDetail?.project_content}
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}

      {/* order details :: 견적서 외 '주문' 상품 결제 정보 */}
      {type !== 'estimate' && orderDetail?.step_name !== '주문취소' && (
        <div className="my_container order_detail_form">
          <div className="order_title">
            <h3>{t("payment_information")}</h3> 
          </div>
          <ul className="default_info_table v2">
            <li className="info_item">
              <div className="label label_start">
                <span>{t("order_amount")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail flex-8 column">
                  <p className="price">
                    {paymentDetail?.total_order_price ? formatLocalString(Number(paymentDetail.total_order_price)) : "0"}
                    <i className="won xl">{t("price_txt")}</i>
                  </p>
                  <p className="text_small_b g-80 flex-4 column">
                    {/* '판매' > '보험, 보증금' 미표출  */}
                    <span>
                      {t('product_amount2')}: {paymentDetail?.total_rental_price ? formatLocalString(Number(paymentDetail.total_rental_price)) : "0"}{t('price_txt')}
                    </span>
                    {type !== 'sale' && (
                      <>
                        <span>
                          {t('insurance')}: {paymentDetail?.insurance_price ? formatLocalString(Number(paymentDetail.insurance_price)) : "0"}{t('price_txt')}
                        </span>              
                        <span>
                          {t('deposit')}: {paymentDetail?.deposit_price ? formatLocalString(Number(paymentDetail.deposit_price)) : "0"}{t('price_txt')}
                        </span>
                      </>
                    )}

                    {/*'택배, 판매'일 때만 '배송비 표출 */}
                    {type === 'parcel' || type === 'sale' ? (
                      <span>
                        {t('delivery_fee')}: {paymentDetail?.shipping_cost ? formatLocalString(Number(paymentDetail.shipping_cost)) : "0"}{t('price_txt')}
                      </span>
                    ) : null}
                  </p>
                </div>
              </div>
            </li>

            <li className="info_item">
              <div className="label label_start">
                <span>{t("discount_amount")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail flex-8 column">
                  <p className="price">
                    {paymentDetail?.sale_price ? formatLocalString(Number(paymentDetail.sale_price)) : "0"}
                    <i className="won xl">{t('price_txt')}</i>
                  </p>
                  <p className="text_small_b g-80 flex-4 column">
                    <span>
                      {t('point')}: {paymentDetail?.total_point ? formatLocalString(Number(paymentDetail.total_point)) : "0"}{t('price_txt')}
                    </span>
                    <span>
                      {t('discount')}: {paymentDetail?.total_sale_price ? formatLocalString(Number(paymentDetail.total_sale_price)) : "0"}{t('price_txt')}
                    </span>
                  </p>
                </div>
              </div>
            </li>

            <li className="info_item">
              <div className="label label_start">
                <span>{t("payment_amount")}</span>
              </div>
              <div className="form_info payment_info">
                <div className="info_detail flex-8 column">
                  <p className="price">
                    {paymentDetail?.total_payment ? formatLocalString(Number(paymentDetail.total_payment)) : "0"}
                    <i className="won xl">{t('price_txt')}</i>
                  </p>
                  <div className="text_small_b g-80 flex-4 column">
                    <span>
                      {paymentDetail?.payment}: {paymentDetail?.settleprice ? formatLocalString(Number(paymentDetail.settleprice)) : "0"}{t('price_txt')}
                    </span>
                    {/* 무통장 입금 > '판매' 에서만 가능 */}
                    {orderDetail?.step_name === '입금전' && type === 'sale' && (
                    <span>
                      {paymentDetail?.payment}
                    </span>
                    )}
                    <span>
                      {t('deposit_info_8')}: {paymentDetail?.balance ? formatLocalString(Number(paymentDetail.balance)) : "0"}{t('price_txt')}
                    </span>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}

      {/* order details :: 견적서 결제 정보  */}
      {type === 'estimate' && (
        <div className="my_container order_detail_form estimate_detail">
          <div className="order_title">
            <h3>{t("payment_information")}</h3> 
          </div>
          <ul className="default_info_table v2">
            <li className="info_item">
              <div className="label label_start">
                <span>{t("expected_payment_amount")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail flex-8 column">
                  <p className="price">
                    {paymentDetail?.settleprice ? formatLocalString(Number(paymentDetail?.settleprice)) : "0"}
                    <i className="won xl">{t('price_txt')}</i>
                  </p>
                </div>
              </div>
            </li>

            <li className="info_item">
              <div className="label label_start">
                <span>{t("payment_method")}</span>
              </div>
              <div className="form_info">
                <div className="info_detail flex-8 column">
                  <p style={{font:'var(--body1-2)'}}>
                    {paymentDetail?.payment}
                  </p>
                  {/* <p className="text_small_b g-80 flex-4 column">
                    <span>
                      결제 분기 : 계약금, 중도금, 잔금
                    </span>
                  </p> */}
                </div>
              </div>
            </li>

            {/* 견적서 > '계약중', '계약완료' 상태일때 만 '총 결제금액'만 노출 */}

            {['계약중', '계약완료'].includes(orderDetail?.step_name) && (
              <li className="info_item">
                <div className="label label_start">
                  <span>{t("total_payment_amount3")}</span> 
                </div>
                <div className="form_info payment_info">
                  <div className="info_detail flex-8 column">
                    <p className="price">
                      {paymentDetail?.settleprice ? formatLocalString(Number(paymentDetail?.settleprice)) : "0"}
                      <i className="won xl">{t('price_txt')}</i>
                    </p>
                    <div className="text_small_b g-80 flex-4 column">
                      <div className="flex-center-4">
                        <span>{t('down_payment')}: {estimateDetail?.request_deposit ? formatLocalString(Number(estimateDetail.request_deposit)) : "0"}{t('price_txt')}</span>
                        <span className="badge_sm black">{t('payment_completed')}</span>
                      </div>
                      <div className="flex-center-4">
                        <span>{t('interim_payment')}: {estimateDetail?.request_second_deposit ? formatLocalString(Number(estimateDetail.request_second_deposit)) : "0"}{t('days_txt')}</span>
                        <span className="badge_sm g-100">{t('payment_waiting')}</span>
                      </div>
                      <div className="flex-center-4">
                        <span>{t('balance_payment')}: {estimateDetail?.request_last_pay ? formatLocalString(Number(estimateDetail.request_last_pay)) : "0"}{t('days_txt')}</span>
                        <span className="badge_sm g-100">{t('payment_waiting')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            )}
          </ul>
        </div>
      )}

      {/* order details :: 대여상품 정보 */}
      {type !== 'sale' && productDetail?.bundleMain && orderDetail?.step_name !== "주문취소" && (
        <div className="my_container order_detail_form order_page">
          <div className="order_title">
            <h3>{t("rental_product_info")}</h3> 
          </div>
          <ul className="rent order_prod_list quotation_page">
            {productDetail?.bundleMain.map((item, index) => (
              <li key={item.item_option_seq || index}>
                <div className="order_item default_prod">
                  <div className="prod_container" onClick={()=> handleProductDetail(item)}>
                    <img
                      src={item?.goods_image || product}
                      alt="상품 이미지"
                      className="order_prod_img"
                      loading="lazy"
                    />
                    <div className="prod_info">
                      <div className="info_box">
                        <div className="prod_title">
                          <p className="title ellipsis1">{item?.goods_name || '상품명'}</p>
                          <p className="sub_title ellipsis1">{item?.description_kr_01 || ''}</p>
                          {item?.package_name && (
                            <p className="option_count">
                              {t('package')}: {item?.package_name || '데이터 없음'}
                            </p>
                          )}
                          <p className="option_count">{t('quantity_txt')}<span className="quo_count"> :{item?.ea}{t('quantity_count_txt')}</span></p>
                          <p className="strong_b3" style={{marginTop:'8px'}}>₩<span className="strong_b1">{item?.price ? formatLocalString(Number(item?.price)) : '0'}</span></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* bundlePkg 데이터가 있을 경우 패키지 정보 표시 */}
                {item.bundlePkg && item.bundlePkg?.length > 0 && (
                  <div className={`package_con ${isShow[item.item_option_seq] ? 'active' : ''}`}
                      onClick={() => handleShow(item.item_option_seq)}>
                    <div className="package_total flex-justify-center">
                      <div className="flex-center-2">
                        {t('package')}<span className="strong_ch">{item?.bundlePkg.length}</span>{t('quantity_count_txt')}<i className="arrow_icon"></i>
                      </div>
                    </div>
                    {item?.bundlePkg.map((pkgItem, pkgIndex) => (
                      <div key={pkgItem.item_option_seq || pkgIndex} className="package_item">
                        <div className="prod_container">
                          <img
                            src={pkgItem.goods_image || product}
                            alt="상품 이미지"
                            className="order_prod_img"
                            loading="lazy"
                          />
                          <div className="prod_info">
                            <div className="info_box">
                              <div className="prod_title">
                                <p className="title ellipsis1">{pkgItem?.product_name || '패키지 상품명'}</p>
                                <p className="sub_title ellipsis1">{pkgItem?.description_kr_01 || ''}</p>
                                <p className="option_count">X{pkgItem?.ea}</p>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                  {/* bundleCp 데이터가 있을 경우 패키지 정보 표시 */}
                  {item.bundleCp && item.bundleCp?.length > 0 && (
                  <div className={`package_con ${isShow[item.item_option_seq] ? 'active' : ''}`}
                      onClick={() => handleShow(item.item_option_seq)}>
                    <div className="package_total flex-justify-center">
                      <div className="flex-center-2">
                        구성품<span className="strong_ch">{item?.bundleCp.length}</span>{t('quantity_count_txt')}<i className="arrow_icon"></i>
                      </div>
                    </div>
                    {item?.bundleCp.map((pkgItem, pkgIndex) => (
                      <div key={pkgItem.item_option_seq || pkgIndex} className="package_item">
                        <div className="prod_container">
                          <img
                            src={pkgItem.goods_image || product}
                            alt="상품 이미지"
                            className="order_prod_img"
                            loading="lazy"
                          />
                          <div className="prod_info">
                            <div className="info_box">
                              <div className="prod_title">
                                <p className="title ellipsis1">{pkgItem?.product_name || '패키지 상품명'}</p>
                                <p className="sub_title ellipsis1">{pkgItem?.description_kr_01 || ''}</p>
                                <p className="option_count">X{pkgItem?.ea}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </li>
            ))}
            
          </ul>
        </div>
      )}

      {/* order details :: 부가품목 정보 */}
      {type !== 'sale' && productDetail?.bundleAdd?.length > 0 && (
        <div className="my_container order_detail_form order_page">
          <div className="order_title">
            <h3>{t("additional_item_info")}</h3> 
          </div>

          {/* 아래 ui처럼 OrderItem 분기 필요*/}
          {productDetail?.bundleAdd.map((item, index) => (
          <div className="order_item default_prod" key={index}>
            <div className="prod_container">
              <img
                src={item?.goods_image}
                alt="상품 이미지"
                className="order_prod_img"
                loading="lazy"
              />
              <div className="prod_info">
                <div className="info_box">
                  <div className="prod_title">
                    <p className="title ellipsis1">{item?.product_name}</p>
                    <p className="option_count">{t('quantity_txt')}<span className="quo_count"> :{item?.ea}{t('quantity_count_txt')}</span></p>
                    <p className="strong_b3" style={{marginTop:'8px'}}>₩<span className="strong_b1"></span>{item?.price ? formatLocalString(Number(item?.price)) : "0"}</p>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          ))}
        </div>
      )}

      {/* order details :: 액세서리 정보 */}
      {type !== 'sale' && productDetail?.bundleAcc?.length > 0 && orderDetail?.step_name !== "주문취소" && (
        <div className="my_container order_detail_form order_page">
          <div className="order_title">
            <h3>{t("accessory_info")}</h3> 
          </div>

          {productDetail?.bundleAcc.map((item, index) => (
          <div className="order_item default_prod" key={index}>
            <div className="prod_container">
              <img
                src={item.goods_image}
                alt="상품 이미지"
                className="order_prod_img"
                loading="lazy"
              />
              <div className="prod_info">
                <div className="info_box">
                  <div className="prod_title">
                    <p className="title ellipsis1">{item?.product_name}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ))}
        </div>
      )}

      {/* order details :: 취소 정보 > '매장', '택배', '판매' 취소 상세  */}
      {(orderDetail?.step_name === '취소완료' || orderDetail?.step_name === '주문취소') && (
      <div className="my_container order_detail_form">
        <div className="order_title">
          <h3>{t("cancel_info")}</h3>
        </div>
        <ul className="default_info_table v2">
          <li className="info_item">
            <div className="label label_start">
              <span>{t("refund_amount2")}</span>
            </div>
            <div className="form_info payment_info">
              <div className="info_detail flex-8 column">
                <p className="price red">
                  {paymentDetail?.settleprice ? formatLocalString(Number(paymentDetail.settleprice)) : "0"}
                  <i className="won xl">{t('price_txt')}</i>
                </p>
                <div className="text_small_b g-80 flex-4 column">
                  <div className="flex-center-4">
                    {t('card_refund')}: {paymentDetail?.card ? formatLocalString(Number(paymentDetail.card)) : "0"}{t('price_txt')}
                  </div>
                  <div className="flex-center-4">
                    {t('deposit_info_23')}: {paymentDetail?.balance ? formatLocalString(Number(paymentDetail.balance)) : "0"}{t('price_txt')}
                  </div>
                  <div className="flex-center-4">
                    {t('point_refund2')}: {paymentDetail?.total_point ? formatLocalString(Number(paymentDetail.total_point)) : "0"}{t('price_txt')}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      )}
      
      {/* order details :: 요청 사항 */}
      {orderDetail?.user_momo && (
      <div className="my_container order_detail_form">
        <div className="order_title">
          <h3>{t("request")}</h3> 
        </div>
        <ul className="default_info_table v2">
          <li className="info_item">
            <div className="form_info user_memo">
              {orderDetail?.user_momo}
            </div>
          </li>
        </ul>
      </div>
      )}

      {/* 목록 버튼 */}
      <div className="submit_box">
        <button
          className="default_btn white lg"
          onClick={handleBackToList}
          >{t("list_0617")}
        </button>
      </div>


      {/* 재주문 팝업 */}
      <ReOrderPopup 
        isPopup={requestReorder} 
        setIsPopup={setRequestReorder}
        orderType={type === 'visit' ? 'visit' : 'parcel'}
        orderNumber={orderNumber}
      />

      <ReviewPopup
        isPopup={writeReview}
        setIsPopup={setWriteReview}
        type={type}
        order_seq={orderDetail?.order_seq}
      />

      <PopupLoginError isPopup={isPopupLoginError} setIsPopup={setIsPopupLoginError} onConfirm={handleConfirm}/>
            
      {/* 배송조회 팝업 */}
      <DeliveryStatusPopup
        isPopup={isStatusPopup} 
        setIsPopup={setStatusPopup} 
      />

    </div>
  )
};

export default OrderDetail;